import React from 'react';

const Categories = () => (
  <main>
    <h1>Under construction :&#41;</h1>
  </main>
);

export default Categories;
